"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgWeatherRain05 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M29.333 21.333a8 8 0 0 1-16 0c0-5.751 8-18.666 8-18.666s8 12.915 8 18.666M10.667 12a4 4 0 0 1-8 0c0-2.876 4-9.333 4-9.333s4 6.457 4 9.333" }))); };
exports.default = SvgWeatherRain05;
//# sourceMappingURL=WeatherRain05.js.map